import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../../supabase';
import { BlockText, BlockAlert, BlockImage, BlockSpace, BlockMetrics, BlockVideo,
     BlockLoading, BlockPrice, BlockButton, BlockQuiz, BlockTestimonial,  BlockForm, BlockLevels, BlockCards, BlockScript
     } from '../../components/blocks';
import { FaArrowLeft } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';

export default function PublicFunnel() {
    const { id } = useParams();
    const [funnelData, setFunnelData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [steps, setSteps] = useState([]);
    const [currentStepIndex, setCurrentStepIndex] = useState(null);
    const [settingsFunnel, setSettingsFunnel] = useState({});
    const [leadData, setLeadData] = useState({});
    const [choices, setChoices] = useState({});
    const [started, setStarted] = useState(false);
    const [visitorId, setVisitorId] = useState(uuidv4());
    const [tracking, setTracking] = useState(null);

    // If any GET param on the URL, set as tracking
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        // If there is at least one param, set tracking to the full query string
        if ([...params].length > 0) {
            setTracking(window.location.search.replace(/^\?/, ''));
        }
    }, []);

 

 

  

    useEffect(() => {
      const fetchFunnel = async () => {
        try {
          console.log(id);
          setLoading(true);
          
          // First try to find by slug (works for both UUIDs and strings)
          let { data, error } = await supabase
            .from('funnels')
            .select('*')
            .eq('slug', id);
          
          // If not found by slug and id looks like a UUID, try by uuid field
          if ((!data || data.length === 0) && !error) {
            const isUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
            if (isUUID) {
              ({ data, error } = await supabase
                .from('funnels')
                .select('*')
                .eq('uuid', id));
            }
          }
          
          if (error) {
            setError(error.message);
            return;
          }
          
          if (data && data.length > 0) {
             await setFunnelData(data[0]);
            
            const parsedSettings = JSON.parse(data[0].settings);
            setSettingsFunnel(parsedSettings);

            // Parse the funnel steps here to avoid infinite loops
            try {
              const parsedSteps = Array.isArray(data[0].funnel)
                ? data[0].funnel
                : Array.isArray(JSON.parse(data[0].funnel))
                  ? JSON.parse(data[0].funnel)
                  : [JSON.parse(data[0].funnel)];
              
              setSteps(parsedSteps); 
              
              // Set the current step index based on settings funnel start step
              if(parsedSettings.startStep && parsedSettings.startStep.target){
                
                const startStepIndex = parsedSteps.findIndex(step => step.id === parsedSettings.startStep.target);
                if(startStepIndex !== -1) {
                  setCurrentStepIndex(startStepIndex);

                } else {
                  // Fallback to first step if start step not found
                  setCurrentStepIndex(0);
                  
                }
              } else {
                // Default to first step if no start step is configured
                setCurrentStepIndex(0);

              }
            } catch (parseError) {
              console.error('Error parsing funnel data:', parseError);
              setError('Error parsing funnel data');
            }

            
          }


        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
           

        }
      };
      
      fetchFunnel();
       

    }, [id]);
 

    const goToNextStep = () => {
      if (currentStepIndex < steps.length - 1) {
        setCurrentStepIndex(currentStepIndex + 1);
      }
    };

    const goToPreviousStep = () => {
      if (currentStepIndex > 0) {
        setCurrentStepIndex(currentStepIndex - 1);
      }
    };

    const goToStep = (block) => {
      // Fixed: Remove broken/meaningless forEach, implement correct goToStep logic
      if (!block) return;
 
      // Blur any selection on the page (remove highlight/selection)
      if (window.getSelection) {
        const selection = window.getSelection();
        if (selection && selection.removeAllRanges) {
          selection.removeAllRanges();
        }
      } else if (document.selection) {
        // For IE
        document.selection.empty();
      }
    
      // Validate required form inputs before navigation
      let hasValidationErrors = false;
      const currentStep = steps[currentStepIndex];
      const formValues = [];
      currentStep.blocks.forEach(stepBlock => {
      
        if(stepBlock.type === 'form') {
           
          stepBlock.inputs.forEach(input => {
            const inputElement = document.querySelector(`input[data-input-id="${input.id}"]`);
             
            
            if(input.required === true) {
              const containerElement = document.getElementById(`input-container-${input.id}`);
              
              if (inputElement && (!inputElement.value || inputElement.value.trim() === '')) {
                // Add validation error styling
                hasValidationErrors = true;
                
                // Add animate property to trigger shake and red border
                input.animate = true;
                
                // Remove animation after it completes
                setTimeout(() => {
                  input.animate = false;
                  // Force re-render by updating the steps state
                  setSteps([...steps]);
                }, 5000);
                
                containerElement.classList.add('border-red-500');
                if (containerElement) {
                  containerElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                // Force re-render to show animation immediately
                setSteps([...steps]);
              } else {
                // Remove validation error styling if input is now valid
                input.animate = false;

                if(input.name != ''){
                  formValues.push({[input.name]: inputElement.value});
                }else{
                  formValues.push({[input.type]: inputElement.value});
                }
                
              }


              }

            // Instead of replacing leadData, add/update the value in the object (accumulate all fields)
            setLeadData(prev => ({
              ...prev,
              [inputElement.name]: inputElement.value
            }));
            
          });
        }
      });

     
      
      // Don't navigate if there are validation errors
      if (hasValidationErrors) {
        return;
      }

     


      // Navigate to target step
      let targetStepId = block.target;


 
       if (targetStepId) {
        const foundIdx = steps.findIndex(step => step.id === targetStepId);
        if (foundIdx !== -1) {

         
          if(block.type === 'button') {
            var optionTitle = block.text;
          
          }else{
            var optionTitle = block.content;
          }
          if(formValues.length > 0) {
            var values = formValues;
          }
  
          setCurrentStepIndex(foundIdx);
 

          
        }
      }

      if(block.destinationType === 'url'){

      

         
          if(block.type === 'button') {
            var optionTitle = block.text;
          
          }else{
            var optionTitle = block.content;
          }
         

          window.open(block.url, '_self');
     
      }

       

    };

    function BlockPreview({ block, className, isEditing, setCurrentStepIndex }) {

      window.scrollTo({ top: 0, behavior: 'smooth' });

     
      if(block.content){
        if(block.content.includes('{today}')){
          block.content = block.content.replace('{today}', new Date().toLocaleDateString('pt-BR'));
        }

        if(block.content.includes('{name}')){
          block.content = block.content.replace('{name}', leadData.name);
        }

      
      
        
      }
      if (block.type === 'button') { 
          return (
            <div
              style={{  cursor: 'pointer', transition: 'transform 0.2s cubic-bezier(.4,2,.6,1)' }}
              onClick={e => {
                const el = e.currentTarget;
                el.style.transform = 'scale(0.93)';
                setTimeout(() => {
                  el.style.transform = 'scale(1)';
                   
                  
                    goToStep(block);
                  
   
                }, 250);
              }}
            >
              <BlockButton block={block} className={className} isEditing={false} settingsFunnel={settingsFunnel} />
            </div>
          );
        }
      
        if (block.type === 'text') {
          return (
            <BlockText block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
        if (block.type === 'levels') {
          return (
            <BlockLevels block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'image') {
          return (
            <BlockImage block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'alert') {
          return (
            <BlockAlert block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'space') {
          return (
            <BlockSpace block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'metrics') {
          return (
            <BlockMetrics block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'video') {
          return (
            <BlockVideo block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'loading') {

          
            setTimeout(() => {
              if (block.destinationType !== 'none') {
                goToStep(block);
              }
            }, block.duration);
          
 
          return (


            <BlockLoading block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'price') {
          return (
            <BlockPrice block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'quiz') {
          return (
            <BlockQuiz block={block} className={className} isEditing={isEditing} goToStep={goToStep} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'testimonial') {
          return (
            <BlockTestimonial block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }

        if (block.type === 'cards') {
          return (
            <BlockCards block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }
      
        if (block.type === 'form') {
          return (
            <BlockForm block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }

        if (block.type === 'script') {
          return (
            <BlockScript block={block} className={className} isEditing={isEditing} settingsFunnel={settingsFunnel} />
          );
        }   
      
        // Default preview for other types
        return (
          <div className={`rounded-xl p-3 shadow bg-white w-full ${className || ''}`}>
            <div className="flex items-center gap-2">
              <span className="text-2xl">{block.icon}</span>
              <span className="font-medium">{block.label}</span>
            </div>
          </div>
        );
      }

    if (loading) {
      return (
        <div className="flex flex-col items-center justify-center h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          
        </div>
      );
    }

    if (error) {
      return (
        <div className="flex flex-col items-center justify-center h-screen">
          <div className="text-red-500 text-center">
            <p className="text-xl font-semibold">Error loading funnel</p>
            <p className="mt-2">{error}</p>
          </div>
        </div>
      );
    }

    if (!steps.length || !steps[currentStepIndex] || !steps[currentStepIndex].blocks) {
      return (
        <div className="flex flex-col items-center justify-center h-screen">
          <p className="text-gray-600">No funnel content found</p>
        </div>
      );
    }

    const currentStep = steps[currentStepIndex];

    

    let showLogo = currentStep.showLogo;
    let showProgress = currentStep.showProgress;
    let showBack = currentStep.showBack;
    let logo = settingsFunnel.logo;
    let nodes = steps;
    let node = currentStep;
    
  console.log(settingsFunnel.spacing);
    return (
       <div className="flex flex-col items-center justify-center h-full pt-5 pb-[100px] w-full " style={{backgroundColor: settingsFunnel.backgroundColor, height: '100vh'}}>
         <div className="flex flex-col items-center top-10 h-full w-screen "  style={{maxWidth: '600px'}}> 
             {/* Step indicator */}
             <div className="flex flex-col px-4 w-full justify-center items-center"   >
                 
                 {showLogo && 
                 <div className="flex flex-row items-center justify-center w-full gap-3 " style={{marginBottom: `${settingsFunnel.spacing}px`}}>
                  {logo ? (
                    <img src={logo} alt="Logo"  style={{ width: `${settingsFunnel.logoWidth}px` }} />
                  ) : (
                    <div className="w-20 h-20 flex items-center justify-center border-2 border-dashed border-gray-300 rounded-lg text-xs text-gray-400 bg-gray-50">
                      Sua Logo
                    </div>
                  )}
                 
                 </div>
                 }

                 {showProgress && nodes && nodes.length > 1 && (
                   <div className="flex flex-row px-4 w-full justify-center items-center " style={{marginBottom: `${settingsFunnel.spacing}px`}}>
                     <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
                       <div
                         className="h-2   transition-all duration-300" 
                         style={{
                          background: settingsFunnel.primaryColor,
                           width: `${
                             Math.round(
                               ((nodes.findIndex(n => n.id === node.id) + 1) / nodes.length) * 100
                             )
                           }%`
                         }}
                       ></div>
                     </div>
                     
                   </div>
                 )}

                 
                 {showBack && 
                 <div className="flex flex-row items-center justify-center absolute top-10 left-5">
                   <div className="w-10 h-10 rounded-full">
                     <FaArrowLeft style={{color: settingsFunnel.primaryColor}} />
                   </div>
                 </div>
                 }
                
            </div>
             
             {currentStep.blocks.map((block, index) => (
                 <div key={index} className="w-full px-3 py-1"> 
                     <BlockPreview block={block} className="" isEditing={false} setCurrentStepIndex={setCurrentStepIndex} />
                 </div>
             ))}
         </div>

         <div className=" flex flex-col items-center justify-center w-full text-center bg-black h-20 text-gray-500 text-sm absolute bottom-0 left-0">
            ESSA É UMA PREVISUALIZAÇÃO DO FUNNEL.. NÂO COMPARTILHE O LINK.
          </div>
       </div>
    );
}